<template>
  <div class="days-of-week">
    <div class="day">S</div>
    <div class="day">M</div>
    <div class="day">T</div>
    <div class="day">W</div>
    <div class="day">T</div>
    <div class="day">F</div>
    <div class="day">S</div>
  </div>
</template>

<style scoped>
.days-of-week {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 10px 0;
  font-size: 14px;
  line-height: 21px;
}

.days-of-week * {
  color: #868686;
}

.days-of-week .day {
  width: 46px;
  text-align: center;
}

</style>
